// extracted by mini-css-extract-plugin
export default {"card":"Empty_card__iJlT-","lottie":"Empty_lottie__PgfTQ","label":"Empty_label__pkI9G","description":"Empty_description__jzbjz"};